import React, { useEffect, useState } from 'react';
import { toSnakeCase } from '@/utils/toSnakeCase';
import Icon from '@/components/icon/Icon';
import { IconsDictionary } from '@/components/icon/Icon.types';
import Tooltip from '@/components/tooltip/Tooltip';
import EntryLinkStyled from './EntryLink.styled';

interface LinkProps {
  text: string;
  icon: IconsDictionary;
  tooltipText: string;
}

const EntryLink = ({ text, icon, tooltipText }: LinkProps) => {
  const [path, setPath] = useState('');

  return (
    <EntryLinkStyled
      href={path}
      onClick={() => {
        const entryId = window.ContensisEntryId;
        const projectApiId = window.ContensisProjectApiId;
        const alias = window.ContensisAlias;
        const language = window.ContensisEntryLanguage || '';

        const path = `https://cms-${alias}.cloud.contensis.com/app/projects/${projectApiId}/entries/${entryId}/${language}`;
        setPath(path);
      }}
      target="_blank"
      rel="noopener noreferrer"
      data-id="toolbar-btn"
      aria-describedby={toSnakeCase(tooltipText) || ''}
    >
      <span className="sr-only">{text} (Opens in a new window)</span>
      <Icon icon={icon} color="var(--color-white)" />
      {tooltipText && <Tooltip className="link__tooltip" text={tooltipText} />}
    </EntryLinkStyled>
  );
};

export default EntryLink;
